import { faCopy } from '@fortawesome/pro-light-svg-icons'

import {
  DashboardModuleListItem,
} from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'
import copyToClipboard from '@functions/copyToClipboard'

import useMediaLink from '@hooks/useMediaLink'

import { MediaLinkModel } from '@domain-group/realhub-backend-api-types'

type MediaLinkProps = {
  mediaLink: MediaLinkModel,
  readOnly?: boolean,
}

const MediaLinkListItem = (props: MediaLinkProps) => {
  const { mediaLink, mediaLink: { link_type, linkable_type }, readOnly } = props

  const mediaLinkPayload = useMediaLink(mediaLink)

  const {
    callbacks: { createOrEditMediaLink, deleteMediaLink: deleteFn },
    mediaLink: { url },
    title,
  } = mediaLinkPayload

  const editAndDeleteDisabled = (link_type === 'microsite' || link_type === 'interactive_image')
  const mediaOrExternalText = linkable_type && linkable_type === 'Campaign' ? 'External Link' : 'Media Link'

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      entityName: mediaOrExternalText,
    },
  }

  return (
    <DashboardModuleListItem
      secondaryText={url}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          onClick={() => copyToClipboard(url)}
          icon={faCopy}
        />

        {!editAndDeleteDisabled && !readOnly && (
          <>
            {/*
             // @ts-expect-error TS2339 */}
            <DashboardModuleListItem.Icon
              boxProps={{ marginLeft: 'medium' }}
              onClick={() => createOrEditMediaLink()}
              type="edit"
            />

            {/*
             // @ts-expect-error TS2339 */}
            <DashboardModuleListItem.Icon
              boxProps={{ marginLeft: 'medium' }}
              onClick={() => confirmDelete(confirmDeletePayload)}
              type="delete"
            />
          </>
        )}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default MediaLinkListItem
